/*
 * @Author:dongzhuo
 * @Date: 2021-04-01 16:36:55
 * @Description: 自动获取各服务下各方法（便于后端查找）
 */
let exportApis = {}; // 存储下各API
const APIS = require.context("./modules", true, /\.js$/);
APIS.keys().forEach(api => {
  exportApis = { ...exportApis, ...APIS(api).default };
});
export default exportApis;
